<template v-cloak>
    <!-- eslint-disable max-len -->
    <el-form
        ref="form"
        :model="form"
        class="dialog container form"
        @submit.prevent=""
        @keyup.enter.native="submitForm"
    >
        <el-dialog :visible.sync="dialogVisible" :lock-scroll="false">
            <h3 slot="title" class="text-center">
                {{ cookieText.cookieTitle }}
            </h3>
            <div class="el-dialog__content">
                <div class="row justify-content-center">
                    <div class="col-12 mb-2">
                        {{ cookieText.cookieText }}
                    </div>
                    <div class="col-12">
                        <el-checkbox
                            checked="checked"
                            disabled
                            name="ownCookies"
                            ><span>{{
                                cookieText.cookieNecessaryText
                            }}</span></el-checkbox
                        >
                    </div>
                    <div class="col-12">
                        <el-checkbox
                            v-model="form.allowCookies"
                            name="allowCookies"
                            ><span>{{
                                cookieText.cookieOthersText
                            }}</span></el-checkbox
                        >
                    </div>
                </div>
                <div class="row text-center mt-4">
                    <div class="col-12">
                        <button
                            type="button"
                            class="btn btn-primary"
                            :class="{ 'btn--disabled': processing }"
                            @click.prevent="submitForm"
                        >
                            <span>Cookie informatie opslaan</span>
                        </button>
                        <div
                            v-show="processing"
                            class="loader loader--loading"
                        ></div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </el-form>
</template>

<script>
import Vue from 'vue';
import Axios from 'axios';
import { Form, Dialog, Checkbox } from 'element-ui';
import { EventBus } from '../../js/helpers/eventbus';

Vue.use(Form);
Vue.use(Dialog);
Vue.use(Checkbox);

export default {
    props: {
        cookieText: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            processing: false,
            dialogVisible: false,
            form: {
                allowCookies: true,
                nodeid: window.settings.nodeid
            },
            loginError: false,
            cookieDialog: Boolean
        };
    },
    mounted() {
        EventBus.$on('open-cookiemodal', this.openModel);
        EventBus.$on('accept-cookies', this.submitForm);
    },

    beforeDestroy() {
        EventBus.$off('open-cookiemodal', this.openModel);
        EventBus.$off('accept-cookies', this.submitForm);
    },
    methods: {
        submitForm: function() {
            if (this.processing) return false;
            this.processing = true;
            Axios.post('/api/cookie/post', this.form).then(response => {
                this.cookieText = response;
                location.reload();
            });
        },
        openModel: function() {
            this.dialogVisible = true;
        }
    }
};
</script>
